import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  FormControlLabel,
  Checkbox,
  Divider,
  FormGroup,
} from "@mui/material";
import dayjs from "dayjs";
import { DoubleArrow } from "@mui/icons-material";
import { themes } from "services/constants";
import { CustomTextBox } from "components/CustomComponents";
import { useSelector } from "react-redux";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { customAPI } from "services/utils/CustomAPI";
import { CustomButton } from "components/CustomComponents";
import { CustomButtonWithBorder } from "components/CustomComponents/CustomButton";
import { showToast } from "services/utils/Status";
import CloseIcon from "@mui/icons-material/Close";
import { CustomAutoComplete } from "components/CustomComponents";
import { CustomTimePicker } from "components/CustomComponents/CustomTimePicker";
import { weekdays, dayType } from "pages/Administration/AdministrationHeaders";
import { useForm } from "react-hook-form";
import ShiftGradePreview from "./ViewShiftGrade/ShiftGradePreview";

let count = 0;

export const CreateShiftGradePanel = ({
  onClose,
  reCallApi,
  setHandleLoader,
}) => {
  const {
    setValue,
    unregister,
    register,
    trigger,
    getValues,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      shift_grade_name: "",
      button_loader: false,
      shiftHrs: null,
    },
  });
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const [weekOffDays, setWeekOffDays] = useState([]);
  const [avaliableWeekDays, setAvailableWeekdays] = useState(weekdays);
  const formatSftHrs =
    watch("shiftHrs") && dayjs(watch("shiftHrs")).isValid()
      ? dayjs(watch("shiftHrs")).format("HH:mm")
      : "00:00";

  const addWeekOff = () => {
    let newWeekOff = {
      id: count + 1,
      day: "",
      type: "",
      week: [
        { id: 1, name: "1st", label: "1st", value: false },
        { id: 2, name: "2nd", label: "2nd", value: false },
        { id: 3, name: "3rd", label: "3rd", value: false },
        { id: 4, name: "4th", label: "4th", value: false },
        { id: 5, name: "5th", label: "5th", value: false },
      ],
    };
    count = count + 1;
    setWeekOffDays([...weekOffDays, newWeekOff]);
  };

  const removeWeekOffDay = (id) => {
    let remainingData = weekOffDays?.filter((data) => {
      return data.id !== id;
    });
    setWeekOffDays(remainingData);
    updateAvailableWeekdays(remainingData);
  };

  const dayTypesFliter = (weekofDayDetails) => {
    return dayType?.filter((dt) => {
      const selectedDay = weekOffDays?.find(
        (d) => d?.id === weekofDayDetails?.id
      );
      if (!selectedDay || !selectedDay.day) return true;
      const selectedDayTypes = weekOffDays
        ?.filter((d) => d?.day === selectedDay?.day)
        ?.map((d) => d?.type);

      return !selectedDayTypes?.includes(dt?.label);
    });
  };

  const updateAvailableWeekdays = (weekoffDetails) => {
    let selectedDays = {};

    weekoffDetails?.forEach(({ day, type }) => {
      if (!selectedDays[day]) {
        selectedDays[day] = [];
      }
      if (type) {
        selectedDays[day]?.push(type);
      }
    });

    let newAvailableWeekdays = weekdays?.filter(({ label }) => {
      return !(selectedDays[label] && selectedDays[label]?.length === 2);
    });

    setAvailableWeekdays(newAvailableWeekdays);
  };

  const selectWeekOfDaysDetails = (id) => (event, data) => {
    if (data) {
      setValue(`day_${id}`, data?.label);
      setValue(`shift_${data?.id}`, data?.label);
      let updatedData = weekOffDays?.map((element) =>
        element.id === id ? { ...element, day: data?.label, type: "" } : element
      );

      setWeekOffDays(updatedData);
      updateAvailableWeekdays(updatedData);
    } else {
      setValue(`day_${id}`, "");

      let updatedData = weekOffDays.map((element) =>
        element?.id === id ? { ...element, day: "" } : element
      );

      setWeekOffDays(updatedData);
      updateAvailableWeekdays(updatedData);
    }
  };

  const selectDayTypeDetails = (id) => (event, data) => {
    if (data) {
      setValue(`day_type_${id}`, data?.label);

      let updatedData = weekOffDays?.map((element) =>
        element.id === id ? { ...element, type: data?.label } : element
      );

      setWeekOffDays(updatedData);
      updateAvailableWeekdays(updatedData);
    } else {
      setValue(`day_type_${id}`, "");

      let updatedData = weekOffDays?.map((element) =>
        element?.id === id ? { ...element, type: "" } : element
      );

      setWeekOffDays(updatedData);
      updateAvailableWeekdays(updatedData);
    }
  };

  const handleCheckboxChange = (weekofDayDetails, day) => (event) => {
    let updatedData = weekOffDays?.map((element) => {
      if (element?.id === weekofDayDetails?.id) {
        return {
          ...element,
          week: element?.week?.map((weekItem) =>
            weekItem?.name === day?.name
              ? { ...weekItem, value: event?.target?.checked }
              : weekItem
          ),
        };
      } else {
        return element;
      }
    });
    setWeekOffDays(updatedData);
  };
  const onSubmit = async () => {
    const isValid = await trigger(
      Object.keys(getValues()).filter((key) => key.startsWith("day_"))
    );
    let weekOffArray = [];
    weekOffDays.forEach((element) => {
      let weekRow = [];
      element?.week.forEach((element) => {
        if (element.value) {
          weekRow.push(element.id);
        }
      });
      let week = {
        day: element?.day,
        type: element?.type,
        week_occurrence: weekRow,
      };
      weekOffArray = [...weekOffArray, week];
    });
    const hasEmptyWeekOccurrence = weekOffArray.some(
      (item) => item.week_occurrence.length === 0
    );
    const nonEmptyWeekOccurrences = hasEmptyWeekOccurrence
      ? []
      : weekOffArray.filter((item) => item.week_occurrence.length > 0);
    const hasDuplicateWeekOccurrence = weekOffArray.some((item, index, array) =>
      array.some(
        (otherItem, otherIndex) =>
          index !== otherIndex &&
          item.day === otherItem.day &&
          item.type !== otherItem.type &&
          item.week_occurrence.some((occurrence) =>
            otherItem.week_occurrence.includes(occurrence)
          )
      )
    );
    if (hasDuplicateWeekOccurrence) {
      showToast(
        "error",
        "The same day cannot have overlapping occurrences within a week."
      );
      return;
    }

    if (
      (nonEmptyWeekOccurrences.length !== 0 || weekOffArray?.length === 0) &&
      isValid
    ) {
      setValue("button_loader", true);
      let payload = {
        name: watch("shift_grade_name").trim(),
        shift_hours: formatSftHrs,
        shift_grade_week_off: weekOffArray,
      };
      const response = await customAPI(
        `${domain}administration/shiftroster/shiftgrade/shift-grades/`,
        "POST",
        payload
      );
      if (response.ok) {
        showToast("success", "Shift grade created successfully");
        reCallApi(true);
        setHandleLoader(true);
        onClose();
      } else {
        setValue("button_loader", true);
      }
    } else {
      showToast("error", "Select missing weeks chekbox");
    }
    setValue("button_loader", false);
  };

  const formatWeekoffPreview = (weekoffItem) => {
    if (!weekoffItem) return "";

    const { week, day, type } = weekoffItem;
    const selectedWeeks = week
      ?.filter((w) => w.value)
      .map((w) => w.name)
      .join(" & ");

    return `${selectedWeeks} - ${day}  ${type}`;
  };

  const weekoffValue = weekOffDays.map(formatWeekoffPreview).join("\n");

  const handleName = (event) => {
    setValue("shift_grade_name", event.target.value);
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          sx={{ padding: 1, backgroundColor: themes?.primary }}
        >
          <Box sx={{ ml: 1 }}>
            <IconButton
              onClick={onClose}
              sx={{
                color: themes?.grayColor,
                "&:hover": {
                  backgroundColor: themes?.whiteColor,
                },
              }}
            >
              <DoubleArrow />
            </IconButton>
          </Box>

          <Box sx={{ ml: 2.2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Create Shift Grade
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Specify the employee’s weekoff days and shift working hours;
              per-hour salary is calculated based on the shift grade.
            </Typography>
          </Box>
        </Box>
      </Paper>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2.5,
            }}
          >
            <Box>
              <Box sx={{ ml: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                  Shift Grade Name{" "}
                  <span style={{ color: themes?.redColor }}>*</span>
                </Typography>
                <CustomTextBox
                  selectedValue={watch("shift_grade_name")}
                  rules={{
                    ...register("shift_grade_name", {
                      required: "Shift grade name is required",
                      minLength: {
                        value: 3,
                        message: "Minium length is 3 characters",
                      },
                      maxLength: {
                        value: 100,
                        message: "Maximum length is 100 characters",
                      },
                      validate: {
                        atleastOneCharacterWithSpaceReg: (value) => {
                          if (
                            atleastOneCharacterWithSpace.test(value) ||
                            value === ""
                          ) {
                            return true;
                          } else {
                            return "Atleast one alphabet required";
                          }
                        },
                        checkShiftUniqueName: async (fieldValue) => {
                          if (fieldValue !== "") {
                            const response = await fetch(
                              `${domain}administration/shiftroster/shiftgrade/unique/shift-grade/?name=${fieldValue.trim()}`,
                              {
                                method: "GET",
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: `token ${token}`,
                                },
                              }
                            );
                            const resp = await response.json();
                            if (resp.exists) {
                              return "Shift grade name already exists";
                            }
                          }
                        },
                      },
                    }),
                  }}
                  updateDataFunction={handleName}
                  placeHolder="Enter shift grade name"
                  errorMessage={
                    errors?.shift_grade_name?.message
                      ? errors?.shift_grade_name?.message
                      : ""
                  }
                  textBoxError={errors.shift_grade_name ? true : false}
                />
              </Box>
            </Box>
            <Box
              sx={{
                ml: 1,
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>
                Shift Hours Policy
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Configure shift duration rules
              </Typography>
            </Box>
            <Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 4,
                  ml: 1,
                }}
              >
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                    Shift Hours{" "}
                    <span style={{ color: themes?.redColor }}>*</span>
                  </Typography>
                  <CustomTimePicker
                    name="shiftHrs"
                    control={control}
                    errors={errors}
                    validateFn={(value) => {
                      if (!value || !dayjs(value).isValid()) {
                        return "Shift hours is required";
                      }
                      return true;
                    }}
                  />
                </Box>
              </Box>
            </Box>
            <Divider sx={{ borderColor: themes?.miliedLightGray }} />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ ml: 1 }}>
                <Typography sx={{ fontWeight: 600 }}>Week Off</Typography>
                <Typography variant="body2" color="text.secondary">
                  Set specific days as weekly offs for the shift grade
                </Typography>
              </Box>

              <CustomButton
                actionName="Add"
                typeName="button"
                actionFuntion={() => {
                  addWeekOff();
                }}
                disableAction={weekOffDays?.length >= 14}
              />
            </Box>
            <Box>
              {weekOffDays?.map((weekofDayDetails, index) => (
                <Box
                  sx={{
                    padding: 1,
                    border: `1px solid ${themes?.miliedLightGray}`,
                    borderRadius: 2,
                    mt: 0.5,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 1,
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="500">{`Week ${
                      index + 1
                    }`}</Typography>

                    <IconButton
                      onClick={() => {
                        removeWeekOffDay(weekofDayDetails?.id);
                        unregister(`day_type_${weekofDayDetails?.id}`);
                        unregister(`day_${weekofDayDetails?.id}`);
                      }}
                      size="small"
                      sx={{ color: "error.main" }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: 4,
                      ml: 1.5,
                    }}
                  >
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Day
                        <span style={{ color: themes?.redColor }}>*</span>
                      </Typography>
                      <CustomAutoComplete
                        dataList={avaliableWeekDays}
                        selectedValue={weekofDayDetails?.day}
                        rules={{
                          ...register(`day_${weekofDayDetails?.id}`, {
                            required: false,
                            validate: {
                              minLengthNoSpaces: (value) =>
                                !value ? "Day is required" : true,
                            },
                          }),
                        }}
                        updateDataFunction={selectWeekOfDaysDetails(
                          weekofDayDetails?.id
                        )}
                        placeHolder="Select day"
                        errorMessage={
                          errors?.[`day_${weekofDayDetails?.id}`]?.message
                            ? errors?.[`day_${weekofDayDetails?.id}`]?.message
                            : ""
                        }
                        textBoxError={
                          errors?.[`day_${weekofDayDetails?.id}`] ? true : false
                        }
                      />
                    </Box>
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Week Off Type
                        <span style={{ color: themes?.redColor }}>*</span>
                      </Typography>
                      <CustomAutoComplete
                        dataList={dayTypesFliter(weekofDayDetails)}
                        selectedValue={weekofDayDetails?.type}
                        rules={{
                          ...register(`day_type_${weekofDayDetails?.id}`, {
                            required: "Day type is required",
                            validate: {
                              minLengthNoSpaces: (value) =>
                                !value ? "Day type is required" : true,
                            },
                          }),
                        }}
                        updateDataFunction={selectDayTypeDetails(
                          weekofDayDetails?.id
                        )}
                        placeHolder="Select the day type"
                        errorMessage={
                          errors?.[`day_type_${weekofDayDetails?.id}`]?.message
                            ? errors?.[`day_type_${weekofDayDetails?.id}`]
                                ?.message
                            : ""
                        }
                        textBoxError={
                          errors?.[`day_type_${weekofDayDetails?.id}`]
                            ? true
                            : false
                        }
                      />
                    </Box>

                    <Box>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Week Selection
                      </Typography>
                      <FormGroup row>
                        {weekofDayDetails?.week?.map((day) => (
                          <Box key={day.name} sx={{ textAlign: "left" }}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "13px", lineHeight: 1 }}
                            >
                              {day.label}
                            </Typography>
                            <FormControlLabel
                              key={day.name}
                              control={
                                <Checkbox
                                  name={day.name}
                                  checked={day.value}
                                  onChange={handleCheckboxChange(
                                    weekofDayDetails,
                                    day
                                  )}
                                  size="small"
                                />
                              }
                              disabled={weekOffDays.some(
                                (prevWeek) =>
                                  prevWeek.id < weekofDayDetails.id &&
                                  prevWeek.day === weekofDayDetails.day &&
                                  prevWeek.type !== weekofDayDetails.type &&
                                  prevWeek.week.some(
                                    (prevDay) =>
                                      prevDay.name === day.name && prevDay.value
                                  )
                              )}
                              sx={{ mr: 1 }}
                            />
                          </Box>
                        ))}
                      </FormGroup>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
            <Divider sx={{ borderColor: themes?.miliedLightGray }} />
            <Box sx={{ ml: 1 }}>
              <Typography sx={{ fontWeight: 600 }}>Preview</Typography>
            </Box>
            <Box>
              <ShiftGradePreview
                shiftName={watch("shift_grade_name")}
                weekoffValue={weekoffValue}
                shiftDuration={watch("shiftHrs")}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
              }}
            >
              <CustomButtonWithBorder
                actionName="Cancel"
                typeName="button"
                actionFuntion={() => onClose()}
              />
              <CustomButton
                actionName="Create"
                typeName="submit"
                disableAction={watch("button_loader")}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  );
};
